import { Quill } from 'react-quill';
import _ from 'lodash';
import AttachmentBlot from '../attachment/AttachmentBlot';
import Constants from '../Constants';

const Image = Quill.import('formats/image');
Image.sanitize = url => url;

const BlockEmbed = Quill.import('blots/block/embed');
class ImageBlot extends BlockEmbed {
    static create(value) {
        const isInlineImage = _.isPlainObject(value) && value.src;
        if(isInlineImage){
            // This section is for KB, we are supporting inline images in it.
            let node = super.create();
            _.forEach(value, (val, attr) => {
                node.setAttribute(attr, val);
            });
            return node; 
        }

        // This is for Findings, we are supporting images as an attachment.
        if(value.startsWith("data:image") || value.startsWith("file:")){
            return document.createElement("div");
        }
        const id = _.random(0, 1000);
        const name = "image";
        const src = value;
        let node = AttachmentBlot.create([id, name, src].join(Constants.ID_SPLIT_FLAG));
        return node;
    }
    static value(node) {
        return node.src;
    }
};
ImageBlot.blotName = 'image';
ImageBlot.tagName = 'img';

export default ImageBlot;